import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import './confirmModal.scss'

const CancelModal = (props) => {

  return (
    <>
        <Modal show={props.isConfirm} size="sm" aria-labelledby="contained-modal-title-vcenter"
          onHide={() => props.handleClose(false)}
                centered>
                <Modal.Header onClick={() => props.handleClose(false)} closeButton></Modal.Header>
                <Modal.Body>
                    <div className='confirm-modal-wrapper'>
                        <div className='modal-sub-title'>{props.text}?</div>
                        <div className='w-100 confirm-btn-wrapper'><Button onClick={()=>props.handleClose(true)} variant='outline-primary'>Yes</Button> <Button onClick={()=>props.handleClose(false)} variant='outline-primary'>No</Button></div>
                    </div>
                </Modal.Body>
            </Modal>
    </>
  )
}

export default CancelModal
